import { DOMAttr, DangerousHtml, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { Model__get_CanSubmit, Msg } from "./Types.fs.js";
import { spinnerwhite, validatedPasswordBoxWithoutErrorMsg, validatedTextBoxWithoutErrorMsg2 } from "../../../Bfs.Web.Portale/ViewParts.fs.js";
import { Page } from "../Password/Types.fs.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { value } from "../../fable_modules/fable-library-js.4.19.0/Option.js";

export function wartungsmeldungPart(msg) {
    let props;
    const children_2 = [(props = [new HTMLAttr(65, ["content"]), new DOMAttr(0, [new DangerousHtml(msg)])], react.createElement("div", keyValueList(props, 1)))];
    return react.createElement("div", {
        className: "column is-12 image-column is-padded",
    }, ...children_2);
}

export function submitOnEnter(dispatch) {
    return new DOMAttr(15, [(e) => {
        if (e.key === "Enter") {
            dispatch(new Msg(8, [undefined]));
        }
    }]);
}

export function kdnrPasswordForm(model, dispatch, navigateTo) {
    let children, children_2, children_6;
    return [(children = [validatedTextBoxWithoutErrorMsg2([submitOnEnter(dispatch)])((arg_5) => {
        dispatch(new Msg(3, [arg_5]));
    })("Benutzerkennung:")("Benutzerkennung")("12345")(model.Name)], react.createElement("p", {
        className: "info-block",
    }, ...children)), (children_2 = [validatedPasswordBoxWithoutErrorMsg("is-tooltip-right", [submitOnEnter(dispatch)])((arg_11) => {
        dispatch(new Msg(4, [arg_11]));
    })("Passwort:")("Passwort")("")(model.Password)], react.createElement("p", {
        className: "info-block",
    }, ...children_2)), (children_6 = [react.createElement("a", {
        onClick: (_arg) => {
            navigateTo(new Page(0, []));
        },
    }, "Passwort vergessen?")], react.createElement("p", {}, ...children_6))];
}

export function otpForm(model, dispatch) {
    let children_2;
    return [react.createElement("p", {
        className: "content",
    }, "Bitte geben Sie Ihr Einmalpasswort ein:"), (children_2 = [validatedTextBoxWithoutErrorMsg2([new HTMLAttr(54, ["off"]), submitOnEnter(dispatch)])((arg_5) => {
        dispatch(new Msg(5, [arg_5]));
    })("Einmalpasswort:")("Otp")("123456")(model.Otp)], react.createElement("p", {
        className: "info-block",
    }, ...children_2))];
}

export function loginForm(model, dispatch, navigateTo) {
    let children_4, children_2, s_1, children_10;
    const isLoading = model.Sending ? " is-loading" : "";
    const children_12 = [(children_4 = [react.createElement("h2", {}, "Service neu erleben!"), (children_2 = [(s_1 = "Im BFS-Kundenportal erhalten Sie exklusiven Zugriff auf wichtige Informationen, aktuelle News und Hilfe-Themen. Wir freuen uns auf Sie!", s_1)], react.createElement("p", {}, ...children_2))], react.createElement("div", {
        className: "toppart",
    }, ...children_4)), (children_10 = toList(delay(() => append(model.OtpRequired ? singleton(otpForm(model, dispatch)) : singleton(kdnrPasswordForm(model, dispatch, navigateTo)), delay(() => {
        let children_6;
        return append((model.ErrorMsg != null) ? singleton((children_6 = [value(model.ErrorMsg)], react.createElement("p", {
            className: "error-msg",
        }, ...children_6))) : empty(), delay(() => {
            let props_8;
            return singleton((props_8 = [new HTMLAttr(159, ["submit"]), new HTMLAttr(65, ["bfsbutton wide " + isLoading]), new HTMLAttr(79, [!Model__get_CanSubmit(model)]), new DOMAttr(40, [(_arg) => {
                dispatch(new Msg(8, [undefined]));
            }])], react.createElement("button", keyValueList(props_8, 1), "Einloggen")));
        }));
    })))), react.createElement("div", {
        className: "bottompart",
    }, ...children_10))];
    return react.createElement("div", {
        className: "is-form-padded paragraphs form-column",
    }, ...children_12);
}

export const loadingSpinner = (() => {
    const children_2 = [react.createElement("div", {
        className: "spacer",
    }), spinnerwhite];
    return react.createElement("div", {
        className: "column is-4 is-form-padded form-column",
    }, ...children_2);
})();

export function view(model, dispatch, navigateTo) {
    const children = toList(delay(() => {
        const matchValue = model.WartungMsg;
        return (matchValue == null) ? (model.Loading ? singleton(loadingSpinner) : singleton(loginForm(model, dispatch, navigateTo))) : singleton(wartungsmeldungPart(matchValue));
    }));
    return react.createElement("div", {
        className: "loginform is-auto is-auth-form category-header",
    }, ...children);
}

//# sourceMappingURL=View.fs.js.map
